
import React from "react";
import { routes } from "../config/route";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

class Pages extends React.Component {

    constructor(props) {
        super(props)
    }
    render() {
        return (
            <Router basename={"/"}>
                <Switch>
                    {routes.map((route) => (
                        <Route exact={true} path={route.path} component={route.component} key={route.path} />
                    ))}
                </Switch>
            </Router>
        );
    }

}

export default Pages;